import { createBrowserRouter, useRouteError } from 'react-router'
import { AppLayout } from './AppLayout'
import { pageRoutes } from './routes'

// 頁面出錯時內容區空白、錯誤只記在 console。
// 不能省略 errorElement：省略的話 react-router 會顯示它內建的錯誤畫面。錯誤頁要等美術設計稿再做。
function SilentRouteError() {
  console.error(useRouteError())
  return null
}

// 首次載入 lazy 頁面時的過渡畫面：同舊版什麼都不顯示。不給的話 react-router 會在 console 警告
function NoHydrateFallback() {
  return null
}

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <SilentRouteError />,
    HydrateFallback: NoHydrateFallback,
    // 頁面層再掛一層：單頁出錯（含頁面程式檔載不到）只清空內容區，側欄與 header 保留、還能換頁
    children: [{ errorElement: <SilentRouteError />, children: pageRoutes }],
  },
])
